// TDSReportForm.js
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import '../css/TDSReportForm.css';
import { showTestFiscalYear } from '../config/api';

const TDSReportForm = ({ onSubmit, loading, error }) => {
    const [panNo, setPanNo] = useState('');
    const [phoneNo, setPhoneNo] = useState('');
    const [fiscalYear, setFiscalYear] = useState('');
    const navigate = useNavigate();
    const fiscalYearOptions = ['2080/81', '2081/82', '2082/83'];

    if (showTestFiscalYear) {
        fiscalYearOptions.push('3081/82');
    }

    const handleSubmit = async (e) => {
        e.preventDefault();

        // Pass panNo, phoneNo, and fiscalYear to OTPVerification via state
        onSubmit(
            { panNo, phoneNo, fiscalYear },
            () => navigate('/otp-verification', { state: { panNo, phoneNo, fiscalYear } }) // Navigate only if successful
        );
    };

    return (
        <div className="tds-page">
            <div className="tds-shell">
                <section className="tds-intro">
                    <span className="eyebrow">TDS Service Portal</span>
                    <h1>Access your TDS report in a few secure steps</h1>
                    <p className="intro-copy">
                        Verify your PAN, mobile number, and fiscal year to continue to OTP confirmation and download your report.
                    </p>

                    <div className="feature-grid">
                        <div className="feature-card">
                            <strong>Fast verification</strong>
                            <p>Your details are checked before the OTP step so the process stays smooth and secure.</p>
                        </div>
                        <div className="feature-card">
                            <strong>Clear guidance</strong>
                            <p>Helpful on-screen messages make it easier to correct issues without checking browser tools.</p>
                        </div>
                    </div>
                </section>

                <section className="container">
                    <div className="form-header">
                        <h2>Get TDS Report</h2>
                        <p>Enter the registered details exactly as maintained in our records.</p>
                    </div>

                    {error && (
                        <div className="status-card error-message" role="alert">
                            <span className="status-badge">Action needed</span>
                            <p>{error}</p>
                        </div>
                    )}

                    <form onSubmit={handleSubmit}>
                        <div className="form-group">
                            <label htmlFor="panNo">PAN Number</label>
                            <input
                                id="panNo"
                                type="text"
                                value={panNo}
                                onChange={(e) => setPanNo(e.target.value.toUpperCase())}
                                placeholder="Enter your PAN number"
                                required
                                disabled={loading}
                            />
                        </div>
                        <div className="form-group">
                            <label htmlFor="phoneNo">Phone Number</label>
                            <input
                                id="phoneNo"
                                type="text"
                                value={phoneNo}
                                onChange={(e) => setPhoneNo(e.target.value)}
                                placeholder="Enter your registered mobile number"
                                required
                                disabled={loading}
                            />
                        </div>
                        <div className="form-group">
                            <label htmlFor="fiscalYear">Fiscal Year</label>
                            <select
                                id="fiscalYear"
                                value={fiscalYear}
                                onChange={(e) => setFiscalYear(e.target.value)}
                                required
                                disabled={loading}
                            >
                                <option value="">Select Fiscal Year</option>
                                {fiscalYearOptions.map((yearOption) => (
                                    <option key={yearOption} value={yearOption}>
                                        {yearOption}
                                    </option>
                                ))}
                            </select>
                        </div>

                        <button type="submit" disabled={loading}>
                            {loading ? 'Verifying details...' : 'Continue to OTP'}
                        </button>

                        <p className="form-note">
                            Make sure the mobile number matches the one linked to the selected PAN for this fiscal year.
                        </p>
                    </form>
                </section>
            </div>
        </div>
    );
};

export default TDSReportForm;
